import { render, staticRenderFns } from "./LayoutDemo.vue?vue&type=template&id=18670b5d&"
import script from "./LayoutDemo.vue?vue&type=script&lang=js&"
export * from "./LayoutDemo.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports